import React from 'react';
import { Link } from 'react-router-dom';
import { companyJobs } from '../../../data/companyJobs';

const CareerSearchPage = () => {
    return (
        <div className="bg-black text-white min-h-full p-8 md:p-16">
            <div className="max-w-4xl mx-auto">
                <header className="text-center mb-12">
                    <h1 className="text-5xl md:text-6xl font-bold">Careers at Renaisons</h1>
                </header>

                <div className="mb-10 pb-6 border-b border-neutral-800">
                    <p className="font-semibold text-neutral-400">
                        Showing {companyJobs.length} open {companyJobs.length === 1 ? 'position' : 'positions'}
                    </p>
                </div>

                <div className="divide-y divide-neutral-800">
                    {companyJobs.map(job => (
                        <div
                            key={job.id}
                            className="flex flex-col md:flex-row justify-between items-start md:items-center py-6"
                        >
                            <div>
                                <Link
                                    to={`/company/careers/jobs/${job.id}`}
                                    state={{ job }}
                                    className="text-lg font-semibold text-white hover:underline"
                                >
                                    {job.title}
                                </Link>
                                {job.department && (
                                    <p className="text-neutral-400">{job.department}</p>
                                )}
                            </div>
                            <div className="flex items-center gap-4 mt-2 md:mt-0">
                                <span className="text-neutral-300">{job.location}</span>
                                <Link
                                    to={`/company/careers/jobs/${job.id}/apply`}
                                    state={{ job }}
                                    className="text-white font-semibold hover:underline whitespace-nowrap"
                                >
                                    Apply now »
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CareerSearchPage;
